module.exports = __webpack_public_path__ + "img/viessmann-connection-1.0c3257a9.png";